import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar4 from '../components/Navbar4';
import Structured from '../components/Structured';
import InitialInstructions from '../components/InitialInstructions';
import UploadWireframe from '../components/UploadWireframe';
import { getProjectDetails } from '../services/database';


const CreateView = () => {
  
  const location = useLocation();
  const { projectId } = location.state || {};
  const [activeTab, setActiveTab] = useState('structured');
  const [device, setDevice] = useState('Desktop');

  useEffect(() => {
    if (projectId) {
      getProjectDetails(projectId)
        .then((projectDetails) => {
          // Directly access styleChoices from projectDetails
          const deviceSetting = projectDetails?.styleChoices?.device || 'Desktop';
          setDevice(deviceSetting);
        })
        .catch((error) => {
          console.error('Error fetching project details:', error);
        });
    }
  }, [projectId]);

  return (
    <div className='min-h-screen font-sans antialiased'>
      <Navbar4 title='Create View' backPath='/project-details' projectId={projectId} />
      
      <div className='px-4 md:px-8 lg:px-16 py-12 max-w-4xl mx-auto'>
        <div className='flex items-center justify-between mb-8'>
          {/* Describe Section */}
          <div className='flex items-center gap-4 z-10 bg-white pr-4'>
            <div className='w-8 h-8 flex items-center justify-center bg-black text-white rounded-full'>
              1
            </div>
            <h1 className='text-2xl font-bold text-gray-800'>Describe</h1>
          </div>

          {/* Line between Describe and Clarify */}
          <div className='flex-1 h-0.5 bg-gray-300 absolute left-1/4 right-1/4 transform -translate-y-1/2 z-0'></div>

          {/* Clarify Section */}
          <div className='flex items-center gap-4 z-10 bg-white px-4'>
            <div className='w-8 h-8 flex items-center justify-center bg-gray-300 text-white rounded-full'>
              2
            </div>
            <h1 className='text-2xl font-bold text-gray-300'>Clarify</h1>
          </div>
        </div>

        <div className="text-left mb-8">
          <p className="text-lg text-gray-700">
            Describe the user interface for the view you'd like to create. Be as detailed as possible to help our AI generate the best results.
          </p>
        </div>

        {/* Tab Container */}
        <div className='mb-8 border-b'>
          <div className='flex space-x-8'>
            <button
              onClick={() => setActiveTab('structured')}
              className={`pb-4 px-2 ${
                activeTab === 'structured'
                  ? 'border-b-2 border-black text-black font-medium'
                  : 'text-gray-500'
              }`}
            >
              Structured
            </button>
            <button
              onClick={() => setActiveTab('freestyle')}
              className={`pb-4 px-2 ${
                activeTab === 'freestyle'
                  ? 'border-b-2 border-black text-black font-medium'
                  : 'text-gray-500'
              }`}
            >
              Freestyle
            </button>
            <button
              onClick={() => setActiveTab('wireframe')}
              className={`pb-4 px-2 ${
                activeTab === 'wireframe'
                  ? 'border-b-2 border-black text-black font-medium'
                  : 'text-gray-500'
              }`}
            >
              Upload Wireframe
            </button>
          </div>
        </div>

        {activeTab === 'structured' ? (
          <Structured projectId={projectId} device={device} />
        ) : activeTab === 'freestyle' ? (
          <InitialInstructions projectId={projectId} />
        ) : (
          <UploadWireframe projectId={projectId} />
        )}
      </div>
    </div>
  );
};

export default CreateView;